import React, { Component } from "react";
import MainContainer from "../../components/MainContainer";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";

import "react-big-calendar/lib/css/react-big-calendar.css";
import "./Booking.css";

import BookingCalendars from "../../components/booking/bookingCalendars";
import { ProfileType } from "../../types/enum";

@withRouter
@inject("generalProfileStore", "templateStore", "authStore", "bookingRequestStore", "profileStore")
@observer
class Booking extends Component {
    getParameterByName = name => {
        var match = RegExp("[?&]" + name + "=([^&]*)").exec(window.location.search);
        return match && decodeURIComponent(match[1].replace(/\+/g, " "));
    };

    getLegendItems = () => {
        const currentProfile = this.props.profileStore.getCurrentProfile();
        
        let legendItems = [
            { label: "Draft", color: "#64b5f6" },
            { label: "Sent", color: "#1565c0" },
            { label: "Negotiate", color: "#ff0c9c" },
            { label: "In Progress", color: "#1b5e20" },
            { label: "Accepted", color: "#43a047" },
            { label: "Cancelled", color: "#000000" },
            { label: "Unavailable", color: "#696969" }
        ];

        if (
            currentProfile?.type === ProfileType.Agent.ordinal ||
            currentProfile?.type === ProfileType.Staff.ordinal ||
            currentProfile?.type === ProfileType.Venue.ordinal
        ) {
            legendItems.push({ label: "Declined", color: "#b71c1c" });
            legendItems.push({ label: "Resent", color: "#b19cd9" });
        }

        return legendItems;
    };

    render() {
        const legendItems = this.getLegendItems();

        return (
            <main>
                <Header userRole="agent" />
                <Sidebar />
                <MainContainer>
                    <div className="booking-station-header">
                        <h1 className="booking-station-title">Booking Station</h1>
                        <div className="booking-station-legend">
                            {legendItems.map(item => (
                                <div className="booking-station-legend-item" key={item.label}>
                                    <span 
                                        className="booking-station-legend-dot" 
                                        style={{ backgroundColor: item.color }}
                                    />
                                    <span className="booking-station-legend-label">{item.label}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                    <BookingCalendars 
                        actId={this.getParameterByName("actId")}
                        venueId={this.getParameterByName("venueId")}
                        startDate={this.getParameterByName("startDate")}
                    />
                </MainContainer>
            </main>
        );
    }
}
export default Booking;
